import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSearchText = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.searchText],
  (data) => data
);
